import styles from "./SideBar.module.css";

import IconPerfil from "../../assets/IconPerfil.svg";
import IconFavoritos from "../../assets/IconFavoritos.svg";
import IconPedidos from "../../assets/IconPedidos.svg";
import IconChat from "../../assets/IconChat.svg";
import IconEnderecos from "../../assets/IconEnderecos.svg";
import IconCartoes from "../../assets/IconCartoes.svg";

import chatIcon from "../../assets/chatIcon.svg";
import logIcon from "../../assets/logIcon.svg";
import dataIcon from "../../assets/dataIcon.svg";
import productsIcon from "../../assets/productsIcon.svg";
import ordersIcon from "../../assets/ordersIcon.svg";
import taxasIcon from "../../assets/moneyBag.svg";
import usersIcon from "../../assets/usersIcon.svg";
import dashboardIcon from "../../assets/logIcon.svg";
import relatorioIcon from "../../assets/relatorioIcon.png";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import api from "../../utils/axios/api";

export const contentTabOptions = {
  data: "data",
  products: "products",
  orders: "orders",
  chat: "chat",
  logs: "logs",
  profile: "profile",
  favorites: "favorites",
  addresses: "addresses",
  cards: "cards",
  taxas: "taxas",
  dashboard: "dashboard",
  users: "users",
};

interface SidebarProps {
  isSmallScreen?: boolean;
  closeMobileMenu?: () => void;
}

const SideBar = ({ isSmallScreen, closeMobileMenu }: SidebarProps) => {
  const { t } = useTranslation();
  const [userType, setUserType] = useState<
    "client" | "entrepreneur" | "admin" | null
  >(null);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      api
        .get(`/user/${userId}`)
        .then((response) => {
          const role = response.data.role;
          console.log("Role do usuário: ", role);
          if (role === "Client") {
            setUserType("client");
          } else if (role === "Entrepeneur") {
            setUserType("entrepreneur");
          } else if (role === "Admin") {
            setUserType("admin");
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar dados do usuário:", error);
        });
    } else {
      console.warn("No userId found in localStorage.");
    }
  }, []);

  return (
    <div className={isSmallScreen ? styles.containermobile : styles.container}>
      <h2 className={styles.h2}>{t("accountMenu.myAccount")}</h2>

      <nav className={styles.navigationContainer}>
        <ul>
          {userType === "client" && (
            // Links para o cliente
            <>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/client/account/${contentTabOptions.profile}`}
                >
                  <img src={IconPerfil} alt="Profile Icon" />
                  <span>{t("alterarPerfil.profile")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/client/account/${contentTabOptions.favorites}`}
                >
                  <img src={IconFavoritos} alt="Favorites Icon" />
                  <span>{t("accountMenu.favorites")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/client/account/${contentTabOptions.orders}`}
                >
                  <img src={IconPedidos} alt="Orders Icon" />
                  <span>{t("accountMenu.orders")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/client/account/${contentTabOptions.chat}`}
                >
                  <img src={IconChat} alt="Chat Icon" />
                  <span>{t("accountMenu.chat")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/client/account/${contentTabOptions.addresses}/list`}
                >
                  <img src={IconEnderecos} alt="Addresses Icon" />
                  <span>{t("accountMenu.addresses")}</span>
                </Link>
              </li>
              {/* <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/client/account/${contentTabOptions.cards}/list`}
                >
                  <img src={IconCartoes} alt="Cards Icon" />
                  <span>{t("accountMenu.cards")}</span>
                </Link>
              </li> */}
            </>
          )}
          {userType === "entrepreneur" && (
            // Links para o empreendedor
            <>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/entrepreneur/account/${contentTabOptions.data}`}
                >
                  <img src={dataIcon} alt="Data Icon" />
                  <span>{t("accountMenu.data")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/entrepreneur/account/${contentTabOptions.products}/list`}
                >
                  <img src={productsIcon} alt="Products Icon" />
                  <span>{t("accountMenu.products")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/entrepreneur/account/${contentTabOptions.orders}`}
                >
                  <img src={ordersIcon} alt="Orders Icon" />
                  <span>{t("accountMenu.orders")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/entrepreneur/account/${contentTabOptions.chat}`}
                >
                  <img src={chatIcon} alt="Chat Icon" />
                  <span>{t("accountMenu.chat")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/auth/entrepreneur/account/${contentTabOptions.logs}`}
                >
                  <img src={logIcon} alt="Logs Icon" />
                  <span>{t("accountMenu.logs")}</span>
                </Link>
              </li>
            </>
          )}
          {userType === "admin" && (
            // Links para o administrador
            <>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/AdminTaxas`}
                >
                  <img src={taxasIcon} alt="Taxas Icon" />
                  <span>{t("accountMenu.fees")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/AdminDashboard`}
                >
                  <img src={dashboardIcon} alt="Dashboard Icon" />
                  <span>{t("accountMenu.dashboard")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/ListaUsuarios`}
                >
                  <img src={usersIcon} alt="Users Icon" />
                  <span>{t("accountMenu.users")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/AdminRelatorio`}
                >
                  <img src={relatorioIcon} alt="Relatório Icon" />
                  <span>{t("accountMenu.logs")}</span>
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    if (closeMobileMenu) closeMobileMenu();
                  }}
                  to={`/AdminCupons`}
                >
                  <img src={taxasIcon} alt="Cupons Icon" />
                  <span>{t("accountMenu.coupons")}</span>
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>

      {/* {!isSmallScreen && <img className={styles.logoSideBarIcon} src={logoSideBarIcon} alt="Farmácia da Construção" />} */}
    </div>
  );
};

export default SideBar;
